import { mainAdminApi, userApi } from "../config";

export const getAdminBlogs = async () => {
  try {
    const response = await mainAdminApi.get("/get-admin-blogs");
    return response.data;
  } catch (error) {
    console.error("Fetch admin blogs failed:", error);
    return { blogs: [] };
  }
};

export interface AdminReviewParams {
  page?: number;
  limit?: number;
  search?: string;
  rating?: number | string;
}

export interface AdminReviewResponse {
  success: boolean;
  count: number;
  totalPages: number;
  currentPage: number;
  reviews: any[];
  message?: string;
}

export interface AdminReviewDeleteResponse {
  success: boolean;
  message: string;
}

export const getAdminReviews = async (params: AdminReviewParams = {}): Promise<AdminReviewResponse> => {
  try {
    const response = await mainAdminApi.get<AdminReviewResponse>("/reviews", { params });
    return response.data;
  } catch (error: any) {
    console.error("Fetch admin reviews failed:", error);
    throw error;
  }
};

export const deleteAdminReview = async (reviewId: string): Promise<AdminReviewDeleteResponse> => {
  try {
    const response = await mainAdminApi.delete<AdminReviewDeleteResponse>(`/reviews/${reviewId}`);
    return response.data;
  } catch (error: any) {
    console.error("Delete review failed:", error);
    throw error;
  }
};

export const submitCustomerReview = async (reviewData: {
  name?: string;
  rating: number;
  comment: string;
  email?: string;
  phone?: string;
  practitionerName?: string;
  serviceName?: string;
  location?: string;
  bookingId?: string;
  classId?: string;
  instructorId?: string;
}): Promise<{ success: boolean; message: string; review?: any }> => {
  try {
    const response = await userApi.post<{ success: boolean; message: string; review?: any }>("/reviews", reviewData);
    return response.data;
  } catch (error: any) {
    console.error("Submit review failed:", error);
    throw error;
  }
};

export const getUserReviewedBookingIds = async (): Promise<string[]> => {
  try {
    const response = await userApi.get<{ success: boolean; reviewedBookingIds: string[] }>("/user-reviewed-bookings");
    return response.data?.reviewedBookingIds || [];
  } catch (error) {
    console.error("Fetch user reviewed booking IDs failed:", error);
    return [];
  }
};

